import * as JSONdata from './sampleProjects.json';
const data = JSONdata.default


export default function sampleProjects() {

    let projects = []
    let difficulty_levels = []

    for (let project_index = 0; project_index < data.length; project_index++) {
       
        //if diifuclty level already exists
        let difficulty = data[project_index].difficulty;
        if (difficulty_levels.includes(difficulty)) {
            projects[difficulty_levels.indexOf(difficulty)].push(data[project_index])
        }
        //if difficulty level does not exist
        else {
            difficulty_levels.push(difficulty)
            projects.push([data[project_index]])
        }
    }

    return ({
        sample_projects: projects,
        sample_project_difficulty_levels: difficulty_levels
    })

}